module.exports = __webpack_public_path__ + "img/email-automation.4f47e3f3.png";